/*
 * Eleonora theme script.
 * Hero table switching, the bag drawer (Shopify cart), product options, and a few small behaviours.
 * Everything is rendered by Liquid; this only adds behaviour, and each page still works without it.
 */
(function () {
  'use strict';

  var data = {};
  try { data = JSON.parse(document.getElementById('theme-data').textContent); } catch (e) { /* defaults below */ }
  var routes = data.routes || { cart: '/cart', add: '/cart/add', change: '/cart/change' };
  var strings = data.strings || {};

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  // cents -> the shop's money format, without trailing zeros ("$208", "$52.50")
  function money(cents) {
    var value = cents / 100;
    function num(decimals, thousands, point) {
      var parts = value.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(point).replace(new RegExp('\\' + point + '00$'), '');
    }
    return (data.money || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_apostrophe_separator': return num(2, "'", '.');
        default: return num(2, ',', '.');
      }
    });
  }

  /* ---------- bag ---------- */

  function request(url, body) {
    var options = { headers: { Accept: 'application/json' }, cache: 'no-store' };
    if (body) { options.method = 'POST'; options.headers['Content-Type'] = 'application/json'; options.body = JSON.stringify(body); }
    return fetch(url + '.js', options).then(function (r) {
      return r.json().then(function (json) { if (!r.ok) throw json; return json; });
    });
  }

  function renderBag(cart) {
    document.querySelectorAll('[data-bag-count]').forEach(function (el) { el.textContent = cart.item_count; });
    var body = document.querySelector('[data-bag-body]');
    if (!body) return;
    if (!cart.items.length) {
      var empty = document.querySelector('[data-bag-empty]');
      body.innerHTML = empty ? empty.innerHTML : '';
    } else {
      body.innerHTML = cart.items.map(function (item, i) {
        var sub = (item.options_with_values || []).filter(function (o) { return o.name !== 'Title'; })
          .map(function (o) { return o.name + ' ' + String(o.value).toLowerCase(); }).join(', ');
        var image = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=240' : '';
        return '<div class="line">' +
          '<a class="line__img" href="' + esc(item.url) + '">' + (image ? '<img src="' + esc(image) + '" alt="" width="70" height="70">' : '') + '</a>' +
          '<div><p class="line__name">' + esc(item.product_title) + '</p>' + (sub ? '<p class="line__sub caps">' + esc(sub) + '</p>' : '') +
          '<div class="qty"><button type="button" data-bag-step="-1" data-line="' + (i + 1) + '" data-q="' + item.quantity + '" aria-label="' + esc(strings.fewer) + '">&minus;</button><span>' + item.quantity +
          '</span><button type="button" data-bag-step="1" data-line="' + (i + 1) + '" data-q="' + item.quantity + '" aria-label="' + esc(strings.more) + '">+</button></div></div>' +
          '<div class="line__price">' + esc(money(item.final_line_price)) +
          '<button type="button" class="line__remove caps" data-bag-step="0" data-line="' + (i + 1) + '" data-q="0">' + esc(strings.remove) + '</button></div></div>';
      }).join('');
    }
    var total = document.querySelector('[data-bag-total]');
    if (total) total.textContent = money(cart.total_price);
    var foot = document.querySelector('[data-bag-foot]');
    if (foot) foot.hidden = !cart.items.length;
  }

  function refreshBag() { return request(routes.cart).then(function (cart) { renderBag(cart); return cart; }); }
  // Straight after an add, a GET of the cart can still come back as it was (seen as an empty bag until reload).
  // An empty update is a POST, is never served from a cache, and answers with the whole cart.
  function freshBag() { return request(routes.cart + '/update', {}).then(function (cart) { renderBag(cart); return cart; }); }

  var opener = null;
  function openBag(from) {
    opener = from || document.activeElement;
    document.body.classList.add('bag-open', 'is-locked');
    var drawer = document.querySelector('[data-drawer]');
    if (drawer) { drawer.removeAttribute('inert'); var close = drawer.querySelector('[data-bag-close]'); if (close) close.focus({ preventScroll: true }); }
  }
  function closeBag() {
    if (!document.body.classList.contains('bag-open')) return;
    document.body.classList.remove('bag-open', 'is-locked');
    var drawer = document.querySelector('[data-drawer]');
    if (drawer) drawer.setAttribute('inert', '');
    if (opener && opener.focus) opener.focus({ preventScroll: true });
    opener = null;
  }

  /* ---------- hero: pick a table ---------- */

  function initStage(stage) {
    if (stage.hasAttribute('data-ready')) return;
    stage.setAttribute('data-ready', '');
    var media = stage.querySelector('[data-stage-media]');
    var list = stage.querySelector('[data-stage-list]');
    if (!media || !list) return;

    // the other tables download only when someone reaches for the selector, never on first paint
    function wake(picture) {
      picture.querySelectorAll('[data-srcset]').forEach(function (el) { el.setAttribute('srcset', el.getAttribute('data-srcset')); el.removeAttribute('data-srcset'); });
      var img = picture.querySelector('[data-src]');
      if (img) { img.loading = 'eager'; img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
    }
    function wakeAll() { media.querySelectorAll('picture').forEach(wake); }
    ['pointerenter', 'focusin', 'touchstart'].forEach(function (name) { list.addEventListener(name, wakeAll, { once: true, passive: true }); });
    // once the first table is on screen and the page is idle, fetch the others quietly so a tap on a swatch answers at once
    var slow = navigator.connection && (navigator.connection.saveData || /2g/.test(navigator.connection.effectiveType || ''));
    if (!slow) {
      var later = function () { (window.requestIdleCallback || function (fn) { setTimeout(fn, 1200); })(wakeAll); };
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
    }

    var kind = stage.querySelector('[data-stage-kind]'), name = stage.querySelector('[data-stage-name]'), shop = stage.querySelector('[data-stage-shop]'), offer = stage.querySelector('[data-stage-offer]');
    var timer, wanted = null;
    function show(button) {
      var id = button.getAttribute('data-pick');
      wanted = id;
      list.querySelectorAll('button').forEach(function (b) {
        var on = b === button;
        b.classList.toggle('is-on', on);
        if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
      stage.classList.add('is-changing');
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (kind) kind.textContent = button.getAttribute('data-kind') || '';
        if (name) name.textContent = button.getAttribute('data-name') || '';
        if (offer) offer.textContent = button.getAttribute('data-offer') || '';
        if (shop) {
          shop.href = button.getAttribute('data-url') || '#';
          shop.textContent = (strings.shopName || 'Shop [name]').replace('[name]', button.getAttribute('data-name') || '');
        }
        stage.classList.remove('is-changing');
      }, 420);

      var picture = media.querySelector('picture[data-for="' + id + '"]');
      if (!picture) return;
      var img = picture.querySelector('img');
      wake(picture);
      var swap = function () { // only fade once the photo is there, so the table never fades to an empty frame
        if (wanted !== id) return;
        media.querySelectorAll('picture').forEach(function (other) { other.classList.toggle('is-on', other === picture); });
      };
      if (img.complete && img.naturalWidth) swap(); else { img.addEventListener('load', swap, { once: true }); img.addEventListener('error', swap, { once: true }); }
    }
    list.addEventListener('click', function (e) {
      var button = e.target.closest('[data-pick]');
      if (button && !button.classList.contains('is-on')) show(button);
    });
    // a sideways swipe on the photo turns to the next or the previous table
    var startX = null, startY = null;
    media.addEventListener('touchstart', function (e) { if (e.touches.length === 1) { startX = e.touches[0].clientX; startY = e.touches[0].clientY; } else startX = null; }, { passive: true });
    media.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX, dy = e.changedTouches[0].clientY - startY;
      startX = null;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      var buttons = [].slice.call(list.querySelectorAll('[data-pick]'));
      var at = buttons.indexOf(list.querySelector('.is-on'));
      var next = buttons[(at + (dx < 0 ? 1 : -1) + buttons.length) % buttons.length];
      if (next) { show(next); if (next.scrollIntoView) next.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); }
    }, { passive: true });
    stage.showBlock = function (blockId) { var b = list.querySelector('[data-pick="' + blockId + '"]'); if (b) show(b); };
    // the inline script in stage.liquid already put a ?print= table on screen; bring the swatch, name and button along
    var start = stage.getAttribute('data-start');
    var startButton = start && list.querySelector('[data-pick="' + start + '"]');
    if (startButton && !startButton.classList.contains('is-on')) {
      show(startButton);
      list.scrollLeft = startButton.offsetLeft - (list.clientWidth - startButton.offsetWidth) / 2;
    }
  }

  /* ---------- rows, product page, small things ---------- */

  function initRow(row) {
    if (row.hasAttribute('data-ready')) return;
    row.setAttribute('data-ready', '');
    var track = row.querySelector('[data-track]');
    if (!track) return;
    row.querySelectorAll('[data-go]').forEach(function (button) {
      button.addEventListener('click', function () { track.scrollBy({ left: +button.getAttribute('data-go') * track.clientWidth * 0.7, behavior: 'smooth' }); });
    });
  }

  function initProduct(root) {
    if (root.hasAttribute('data-ready')) return;
    root.setAttribute('data-ready', '');
    var form = root.querySelector('[data-product-form]');
    if (!form) return;
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-variants]').textContent); } catch (e) { /* single variant */ }
    var idInput = form.querySelector('[name="id"]'), qtyInput = form.querySelector('[name="quantity"]');
    var add = form.querySelector('[data-add]'), error = form.querySelector('[data-form-error]');
    var price = root.querySelector('[data-price]'), each = root.querySelector('[data-each]'), forSet = root.querySelector('[data-for]'), qtyLabel = form.querySelector('[data-qty]');
    var mirror = form.querySelector('[data-price-mirror]'), addLabel = add.querySelector('[data-add-label]');
    function say(text) { if (addLabel) addLabel.textContent = text; else add.textContent = text; }
    var current = variants.filter(function (v) { return String(v.id) === idInput.value; })[0] || variants[0];

    function choose() {
      var chosen = [].map.call(form.querySelectorAll('[data-option]'), function (group) {
        var input = group.querySelector('input:checked');
        var label = group.querySelector('[data-option-value]');
        if (input && label) label.textContent = input.value.toLowerCase();
        return input ? input.value : null;
      });
      var match = variants.filter(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); })[0];
      if (!match) { add.disabled = true; say(strings.soldOut); return; }
      current = match;
      idInput.value = match.id;
      if (price) price.textContent = match.price;
      if (mirror) mirror.textContent = match.price;
      if (forSet) forSet.textContent = match.set ? (strings.forSet || 'for [set]').replace('[set]', match.set) : '';
      if (each) each.textContent = match.each ? '  ·  ' + (strings.each || '[price] each').replace('[price]', match.each) : '';
      add.disabled = !match.available;
      say(match.available ? strings.add : strings.soldOut);
      try { var url = new URL(location.href); url.searchParams.set('variant', match.id); history.replaceState({}, '', url); } catch (e) { /* older browsers keep the old URL */ }
    }

    form.addEventListener('change', function (e) { if (e.target.matches('[data-option] input')) choose(); });
    form.addEventListener('click', function (e) {
      var step = e.target.closest('[data-qty-step]');
      if (!step) return;
      var quantity = Math.max(1, Math.min(24, +qtyInput.value + +step.getAttribute('data-qty-step')));
      qtyInput.value = quantity;
      if (qtyLabel) qtyLabel.textContent = quantity;
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (add.disabled) return;
      add.disabled = true;
      add.classList.add('is-busy'); // the button answers the tap at once, before the shop does
      if (strings.adding) say(strings.adding);
      if (error) error.textContent = '';
      request(routes.add, { items: [{ id: +idInput.value, quantity: +qtyInput.value || 1 }] })
        .then(freshBag)
        .then(function () { openBag(add); })
        .catch(function (problem) { if (error) error.textContent = (problem && (problem.description || problem.message)) || strings.error; })
        .then(function () {
          add.classList.remove('is-busy');
          add.disabled = current ? !current.available : false;
          say(add.disabled ? strings.soldOut : strings.add);
        });
    });

    var tabs = root.querySelector('[data-tabs]');
    if (tabs) tabs.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-tab]');
      if (!tab) return;
      var index = +tab.getAttribute('data-tab');
      tabs.querySelectorAll('[data-tab]').forEach(function (other) { other.classList.toggle('is-on', other === tab); other.setAttribute('aria-selected', other === tab); });
      tabs.querySelectorAll('.tabs__panel').forEach(function (panel, i) { panel.classList.toggle('is-on', i === index); });
    });
  }

  // the product page mat turns slowly as the page scrolls; it starts dead straight
  var spinning = false;
  function initSpin() {
    if (spinning || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!document.querySelector('[data-spin]')) return;
    spinning = true;
    var queued = false;
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        document.querySelectorAll('[data-spin]').forEach(function (disc) { disc.style.transform = 'rotate(' + (-window.scrollY * +disc.getAttribute('data-spin')).toFixed(2) + 'deg)'; });
      });
    }, { passive: true });
  }

  var observer = null;
  function reveal(scope) {
    var items = (scope || document).querySelectorAll('.reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) { items.forEach(function (el) { el.classList.add('is-in'); }); return; }
    if (!observer) observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('is-in'); observer.unobserve(entry.target); } });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
    items.forEach(function (el) { observer.observe(el); });
  }

  function initHeader() {
    var head = document.querySelector('[data-header]');
    if (!head) return;
    var stage = document.querySelector('[data-stage]');
    if (!stage) { document.body.classList.remove('has-stage'); head.classList.add('is-solid'); return; }
    document.body.classList.add('has-stage');
    var media = stage.querySelector('[data-stage-media]');
    var solid = function () {
      // stacked layout: the caption sits under the photo on paper, so the bar must be solid as soon as the photo has gone by
      var stacked = getComputedStyle(media).position === 'relative';
      var limit = stacked ? media.offsetTop + media.offsetHeight - head.offsetHeight : stage.offsetHeight - 120;
      head.classList.toggle('is-solid', window.scrollY > limit);
    };
    solid();
    window.addEventListener('scroll', solid, { passive: true });
    window.addEventListener('resize', solid);
  }

  // Phones only, and the only place the page ever moves by itself: a downward scroll that stops part-way through
  // the hero is carried on to just under it. Scrolling up, and everything below the hero, is left alone.
  function initHeroSnap() {
    var stage = document.querySelector('[data-stage]');
    var head = document.querySelector('[data-header]');
    if (!stage || !head || !window.matchMedia) return;
    var phone = window.matchMedia('(max-width: 900px)');
    var still = window.matchMedia('(prefers-reduced-motion: reduce)');
    var timer, last = window.scrollY, down = false, touching = false, busy = false;
    function settle() {
      if (!phone.matches || still.matches || touching || busy || !down) return;
      var end = stage.offsetTop + stage.offsetHeight - head.offsetHeight;
      var y = window.scrollY;
      if (y < 24 || y > end - 6) return;
      busy = true;
      window.scrollTo({ top: end, behavior: 'smooth' });
      setTimeout(function () { busy = false; down = false; }, 650);
    }
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y !== last) { if (!busy) down = y > last; last = y; }
      clearTimeout(timer);
      timer = setTimeout(settle, 110);
    }, { passive: true });
    window.addEventListener('touchstart', function () { touching = true; clearTimeout(timer); }, { passive: true });
    window.addEventListener('touchend', function () { touching = false; clearTimeout(timer); timer = setTimeout(settle, 110); }, { passive: true });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-stage]').forEach(initStage);
    scope.querySelectorAll('[data-row]').forEach(initRow);
    scope.querySelectorAll('[data-product]').forEach(initProduct);
    initSpin();
    reveal(scope);
  }

  function ready() {
    init(document);
    initHeader();
    refreshBag().catch(function () { /* the server-rendered count stays */ });
    // a page kept in memory (back button) or loaded ahead of the tap must show the bag as it is now
    var again = function () { refreshBag().catch(function () {}); };
    window.addEventListener('pageshow', function (e) { if (e.persisted) { closeBag(); document.body.classList.remove('menu-open', 'is-locked'); again(); } });
    document.addEventListener('prerenderingchange', again);

    document.addEventListener('click', function (e) {
      var target = e.target.closest('[data-bag-open],[data-bag-close],[data-bag-step],[data-menu-toggle],[data-menu] a');
      if (!target) return;
      if (target.hasAttribute('data-bag-open')) {
        e.preventDefault();
        document.body.classList.remove('menu-open');
        openBag(target);
      } else if (target.hasAttribute('data-bag-close')) {
        closeBag();
      } else if (target.hasAttribute('data-bag-step')) {
        var quantity = +target.getAttribute('data-bag-step') === 0 ? 0 : Math.max(0, +target.getAttribute('data-q') + +target.getAttribute('data-bag-step'));
        request(routes.change, { line: +target.getAttribute('data-line'), quantity: quantity }).then(renderBag).catch(refreshBag);
      } else if (target.hasAttribute('data-menu-toggle')) {
        var open = document.body.classList.toggle('menu-open');
        document.body.classList.toggle('is-locked', open);
        target.setAttribute('aria-expanded', open);
      } else {
        document.body.classList.remove('menu-open', 'is-locked');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      closeBag();
      if (document.body.classList.contains('menu-open')) {
        document.body.classList.remove('menu-open', 'is-locked');
        var toggle = document.querySelector('[data-menu-toggle]');
        if (toggle) { toggle.setAttribute('aria-expanded', 'false'); toggle.focus(); }
      }
    });

    // search: the word in the header opens a line to type on (without script it is a link to the search page)
    var find = document.querySelector('[data-search-toggle]');
    if (find) find.addEventListener('click', function (e) {
      e.preventDefault();
      var open = document.body.classList.toggle('search-open');
      find.setAttribute('aria-expanded', open);
      var field = document.getElementById('header-q');
      if (open && field) field.focus();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && document.body.classList.contains('search-open')) { document.body.classList.remove('search-open'); if (find) { find.setAttribute('aria-expanded', 'false'); find.focus(); } }
    });

    initHeroSnap();

    // the next page starts loading the moment a finger lands on its link, not when it lifts
    var fetched = {};
    function prefetch(e) {
      var link = e.target.closest && e.target.closest('a[href]');
      if (!link || link.origin !== location.origin || link.hash && link.pathname === location.pathname) return;
      if (fetched[link.href] || /\/cart|\/account|\/checkout/.test(link.pathname)) return;
      fetched[link.href] = true;
      var hint = document.createElement('link');
      hint.rel = 'prefetch'; hint.href = link.href;
      document.head.appendChild(hint);
    }
    document.addEventListener('touchstart', prefetch, { passive: true });
    document.addEventListener('mouseover', prefetch, { passive: true });

    // theme editor: sections are re-rendered in place, and selecting a hero block shows that table
    document.addEventListener('shopify:section:load', function (e) { init(e.target); initHeader(); });
    document.addEventListener('shopify:block:select', function (e) {
      var stage = e.target.closest('[data-stage]');
      var button = e.target.querySelector('[data-pick]');
      if (stage && button && stage.showBlock) stage.showBlock(button.getAttribute('data-pick'));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
